import { render, staticRenderFns } from "./aragingselisih.vue?vue&type=template&id=5962233c"
import script from "./aragingselisih.vue?vue&type=script&lang=js"
export * from "./aragingselisih.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports